<template>
  <div class="add-to-cart">
    <input type="number" v-model="quantity" min="1" v-if="!slim">
    <a @click="addToCart" v-text="btnText"/>
  </div>
</template>

<script>
import store from '../store';

export default {
  name: "AddToCart",
  selector: "#vue-add-to-cart",
  store,
  props: {
    slim: { type: Boolean, default: false },
    id: { type: Number, required: true },
    translation: { type:String , requried: true }
  },

  data() {
    return {
      loading: false,
      quantity: 1
    }
  },

  computed: {
    btnText() {
      return this.loading ? 'Loading' : this.translation;
    }
  },

  methods: {
    async addToCart() {
      console.log('adding to cart')
      this.loading = true;
      await this.$store.dispatch('cart/add', { id: this.id, quantity: this.quantity });
      this.quantity = 1;
      this.loading = false;
    }
  }
}
</script>
